// React libraries
import * as React from 'react';
import classnames from 'classnames';
// Custom Styles
import { useStyles } from "./KeyboardCompleteModalStyles";
// Material-UI Core
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Modal } from "../../index";
import { GreyButton } from "../../index";
// Icon
import Space from "../../../icons/Space/Space";
import Capslock from "../../../icons/Capslock/Capslock";
import ChevronLeft from "../../../icons/Chevron/Left";
import ChevronRight from "../../../icons/Chevron/Right";
import Backspace from "../../../icons/Backspace/Backspace";
export const KeyboardCompleteModal = (props) => {
    const classes = useStyles(props);
    const [display, setDisplay] = React.useState("");
    const [capslock, setCapslock] = React.useState(false);
    const [keyboardIndex, setKeyboardIndex] = React.useState(0);
    const { isModalOpen, title, setInitialValue, setOpenModalState, initialValue } = props;
    React.useEffect(() => {
        setDisplay(initialValue);
    }, [initialValue, isModalOpen]);
    const handleAppendChange = (value) => {
        if (capslock) {
            value = value.toUpperCase();
        }
        setDisplay(display.concat(value));
    };
    const handleEraseChange = () => {
        setDisplay(display.substring(0, display.length - 1));
    };
    const changeKeyboardIndexReverse = () => {
        if (keyboardIndex === 0) {
            setKeyboardIndex(4);
        }
        else {
            setKeyboardIndex(keyboardIndex - 1);
        }
    };
    const changeKeyboardIndexForward = () => {
        if (keyboardIndex === 4) {
            setKeyboardIndex(0);
        }
        else {
            setKeyboardIndex(keyboardIndex + 1);
        }
    };
    const changeCapslock = () => {
        setCapslock(!capslock);
    };
    const modalWidth = 285;
    const modalHeight = 350;
    const keys = [
        {
            alphabet: true,
            rows: [
                {
                    cols: [
                        { value: "a" },
                        { value: "b" },
                        { value: "c" },
                        { value: "d" },
                        { value: "e" }
                    ]
                },
                {
                    cols: [
                        { value: "f" },
                        { value: "g" },
                        { value: "h" },
                        { value: "i" },
                        { value: "j" }
                    ]
                },
                {
                    cols: [
                        { value: "k" },
                        { value: "l" },
                        { value: "m" },
                        { value: "n" },
                        { value: "o" }
                    ]
                }
            ]
        },
        {
            alphabet: true,
            rows: [
                {
                    cols: [
                        { value: "p" },
                        { value: "q" },
                        { value: "r" },
                        { value: "s" },
                        { value: "t" }
                    ]
                },
                {
                    cols: [
                        { value: "u" },
                        { value: "v" },
                        { value: "w" },
                        { value: "x" },
                        { value: "y" }
                    ]
                },
                {
                    cols: [
                        { value: "z" },
                        { value: "ä" },
                        { value: "ö" },
                        { value: "ü" },
                        { value: "ß" }
                    ]
                }
            ]
        },
        {
            alphabet: false,
            rows: [
                {
                    cols: [
                        { value: "+" },
                        { value: "*" },
                        { value: "=" },
                        { value: "(" },
                        { value: ")" }
                    ]
                },
                {
                    cols: [
                        { value: "-" },
                        { value: "_" },
                        { value: "[" },
                        { value: "]" },
                        { value: "'" }
                    ]
                },
                {
                    cols: [
                        { value: "`" },
                        { value: "`" },
                        { value: "<" },
                        { value: ">" },
                        { value: "#" }
                    ]
                }
            ]
        },
        {
            alphabet: false,
            rows: [
                {
                    cols: [
                        { value: "/" },
                        { value: "?" },
                        { value: "|" },
                        { value: "{" },
                        { value: "}" }
                    ]
                },
                {
                    cols: [
                        { value: "~" },
                        { value: "$" },
                        { value: "&" },
                        { value: "%" },
                        { value: "$" }
                    ]
                },
                {
                    cols: [
                        { value: "$" },
                        { value: '"' },
                        { value: "!" },
                        { value: "*" },
                        { value: "^" }
                    ]
                }
            ]
        },
        {
            alphabet: false,
            rows: [
                {
                    cols: [
                        { value: "1" },
                        { value: "2" },
                        { value: "3" },
                        { value: "4" },
                        { value: "5" }
                    ]
                },
                {
                    cols: [
                        { value: "6" },
                        { value: "7" },
                        { value: "8" },
                        { value: "9" },
                        { value: "0" }
                    ]
                },
                {
                    cols: [
                        { value: "," },
                        { value: ";" },
                        { value: "." },
                        { value: ":" },
                        { value: "@" }
                    ]
                }
            ]
        }
    ];
    const capslockClasses = classnames({
        [classes.keyboardIcon]: true,
        [classes.keyboardIconActive]: capslock,
    });
    const keyboardButtonClasses = classnames({
        [classes.keyboardButton]: true,
        [classes.keyboardButtonCapslock]: capslock,
    });
    return (React.createElement(Modal, { isModalOpen: isModalOpen, width: modalWidth, height: modalHeight },
        React.createElement("div", { className: classes.floatingDiv },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, md: 12, className: classes.floatingDivBarTop },
                    React.createElement("p", null, title)),
                React.createElement(Grid, { item: true, md: 12, className: classes.keyboardDisplay },
                    React.createElement("p", null, display)),
                React.createElement(Grid, { item: true, md: 12, className: classes.keyboardButtonDiv },
                    keys[keyboardIndex].rows.map((row) => (React.createElement(Grid, { container: true }, row.cols.map((col) => (React.createElement(Grid, { item: true, md: "auto" },
                        React.createElement(Button, { className: keyboardButtonClasses, onClick: () => handleAppendChange(col.value) },
                            React.createElement("p", null, col.value)))))))),
                    React.createElement(Grid, { container: true },
                        React.createElement(Grid, { item: true, md: "auto" },
                            React.createElement(Button, { className: classes.keyboardButtonFix, onClick: () => changeKeyboardIndexReverse() }, keyboardIndex === 0 ? React.createElement("p", null, "123") : React.createElement(ChevronLeft, { className: classes.keyboardIcon }))),
                        React.createElement(Grid, { item: true, md: "auto" },
                            React.createElement(Button, { className: classes.keyboardButtonFix, onClick: () => changeKeyboardIndexForward() },
                                React.createElement(ChevronRight, { className: classes.keyboardIcon }))),
                        keys[keyboardIndex].alphabet ? (React.createElement(Grid, { item: true, md: "auto" },
                            React.createElement(Button, { className: classes.keyboardButtonFix, onClick: () => changeCapslock() },
                                React.createElement(Capslock, { className: capslockClasses })))) : (React.createElement(Grid, { item: true, md: "auto" },
                            React.createElement(Button, { className: classes.keyboardButtonFix, onClick: () => { } },
                                React.createElement("p", null, "")))),
                        React.createElement(Grid, { item: true, md: "auto" },
                            React.createElement(Button, { className: classes.keyboardButtonFix, onClick: () => handleAppendChange(" ") }, React.createElement(Space, { className: classes.keyboardIcon }))),
                        React.createElement(Grid, { item: true, md: "auto" },
                            React.createElement(Button, { className: classes.keyboardButtonFix, onClick: () => handleEraseChange() },
                                React.createElement(Backspace, { className: classes.keyboardIcon }))))),
                React.createElement(Grid, { item: true, md: 6, className: classes.floatingDivBarBottom },
                    React.createElement(GreyButton, { type: "left", onClick: () => { setOpenModalState(false); setDisplay(initialValue); } }, "Cancel")),
                React.createElement(Grid, { item: true, md: 6, className: classes.floatingDivBarBottom },
                    React.createElement(GreyButton, { type: "right", onClick: () => { setInitialValue(display); setOpenModalState(false); setDisplay(""); } }, "Confirm"))))));
};
KeyboardCompleteModal.defaultProps = {
    setInitialValue: () => { },
    setOpenModalState: () => { },
    initialValue: ""
};
export default React.memo(KeyboardCompleteModal);
